import { render, staticRenderFns } from "./TaskReminder.vue?vue&type=template&id=939cf2f4&scoped=true&"
import script from "./TaskReminder.vue?vue&type=script&lang=js&"
export * from "./TaskReminder.vue?vue&type=script&lang=js&"
import style0 from "./TaskReminder.vue?vue&type=style&index=0&id=939cf2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939cf2f4",
  null
  
)

export default component.exports